import base64 from 'base-64';
import authType from '../types/auth.type';
import { Dispatch } from 'redux';
import ILogin from '../../models/ILogin';
import URLConstants from '../constants/url.constants';
import * as services from '../services/services';
import jwt from 'jwt-decode' 

export const loginStart = () => {
	return {
		type: authType.LOGIN_START
	};
};

const loginSuccess = (data: any) => {
	return {
		type: authType.LOGIN_SUCCESS,
		payload: data
	};
};

export const loginFailed = (error: string) => {
	if (error === 'logged') {
		return {
			type: authType.LOGIN_LOGGED,
			payload: error
		};
	}
	else {
		return {
			type: authType.LOGIN_FAILED,
			payload: error
		};
	}
};

const logoutSuccess = () => {
	localStorage.removeItem('token');
	localStorage.removeItem('userType');
	localStorage.removeItem('userId');
	localStorage.removeItem('userName');
	return {
		type: authType.LOGOUT_SUCCESS
	};
};

const updateAuthSuccess = (data: any) => {
	return {
		type: authType.UPDATE_AUTH,
		payload: data
	};
};

export const login = (data: ILogin) => {
	return (dispatch: Dispatch) => {
		dispatch(loginStart());
		const authData = { username: data.username, password: base64.encode(data.password) };
		services.post(URLConstants.Authenticate, authData)
			.then((response: any) => {
				if (response.data === "" || response.data.AuthToken == null) { }
				else {
					let savedLanguage  = localStorage.getItem('language') ?? 'en';
					localStorage.clear();
					const userToken : any = jwt(response.data.AuthToken); 
					localStorage.setItem('token', response.data.AuthToken);
					localStorage.setItem('userName', data.username);
					localStorage.setItem('userId', response.data.UserId);
					localStorage.setItem('userType', userToken.userType.toString());
					localStorage.setItem('language', savedLanguage);
					let userData = {AuthToken:response.data.AuthToken, UserName:data.username, UserId:response.data.UserId, UserType:userToken.userType};
					dispatch(loginSuccess(userData));
				}
			})
			.catch(err => {
				dispatch(loginFailed(err));
			});
	};

};

export const updateAuth = () => {
	return (dispatch: Dispatch) => {
		let data = {
			AuthToken: localStorage.getItem('token'),
			UserName: localStorage.getItem('userName'),
			UserId: localStorage.getItem('userId'),
			UserType: localStorage.getItem('userType'),
		}
		dispatch(updateAuthSuccess(data));
	};
};

export const logout = () => {
	return (dispatch: Dispatch) => {
		dispatch(logoutSuccess());
	};
};

